import { createElement, useMemo } from 'react';

import { TypographyProps, TypographyVariant } from './typography.type';
import { typographyHTMLTags, typographyStyles } from './typography.const';

export const Typography = ({
  children,
  variant = TypographyVariant.BODY_TEXT,
  className,
  as: asProp,
  ...rest
}: TypographyProps) => {
  const style = typographyStyles({ variant, className });
  const defaultAs = useMemo(() => typographyHTMLTags[variant], [variant]);
  const as = asProp || defaultAs;

  const Component = useMemo(() => {
    return createElement(
      as,
      {
        className: style,
        ...rest,
      },
      children,
    );
  }, [as, style, rest, children]);

  return Component;
};
